import { loadStripe, type Stripe } from '@stripe/stripe-js';

const STRIPE_PUBLISHABLE_KEY =
  'pk_live_51NRFOxEj6HHcTsCPvhzzF60Cq1CF8cLb4H5u325kVom6Mo3s5vYG773YjxvDDAm5LQvwYDZHm3y8QWtVAMHCYJJS00nnNHDf1L';

let stripePromise: Promise<Stripe | null> | null = null;
let hasLoggedStripeLoadFailure = false;

export const getStripePromise = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY).catch((error) => {
      if (!hasLoggedStripeLoadFailure) {
        hasLoggedStripeLoadFailure = true;
        console.error('Failed to load Stripe.js', error);
      }
      return null;
    });
  }

  return stripePromise;
};
